/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerImportSampleDownloadResponse } from '../models/CustomerImportSampleDownloadResponse';
import type { ResponseDto_String } from '../models/ResponseDto_String';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomerTitleImportService {

    /**
     * @param formData
     * @returns ResponseDto_String OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerTitleImportImportCustomerTitle(
        formData?: {
            ImportFile?: Blob;
        },
    ): CancelablePromise<ResponseDto_String> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-title-import/import-customer-title',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns CustomerImportSampleDownloadResponse OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppCustomerTitleImportDownloadCustomerTitleImportSample(): CancelablePromise<CustomerImportSampleDownloadResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/customer-title-import/download-customer-title-import-sample',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
